<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content [innerHTML]="data.message" class="mb-3"></mat-dialog-content> <!-- mat-dialog-content -->

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-raised-button [color]="data.btnCancelColor" (click)="onDenial()">
      <mat-icon fontSet="fal" [fontIcon]="data.btnCancelIcon"></mat-icon>
      {{ data.btnCancelText }}
    </a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <button mat-raised-button [color]="data.btnOkColor" (click)="onConfirmation()" *ngIf="!messageOnly">
      <mat-icon fontSet="fal" [fontIcon]="data.btnOkIcon"></mat-icon>
      {{ data.btnOkText }}
    </button>
  </div> <!-- /.col -->
</div> <!-- /.row -->